import { lazy } from 'react';
import { Loadable } from '../components/basics/LazyLoaderComponent/Loadable';
import { ROUTES } from './routes';

const AuthLogin = Loadable(lazy(() => import('../pages/public/authentication/Login')));
const AuthRegister = Loadable(lazy(() => import('../pages/public/authentication/Register')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: ROUTES.public.login,
      element: <AuthLogin />
    }
  ]
};

export default LoginRoutes;
